import React from "react";
import styles from "./CallButton.module.css";

const PhoneIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.6 10.8c1.44 2.83 3.77 5.15 6.6 6.6l2.2-2.2c.28-.28.68-.36 1.03-.25 1.13.37 2.35.57 3.6.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.85 21 3 13.15 3 3.5 3 2.95 3.45 2.5 4 2.5H7.5c.55 0 1 .45 1 1 0 1.25.2 2.47.57 3.6.11.35.03.75-.25 1.03l-2.22 2.17Z"
      fill="#fff"
    />
  </svg>
);

const CallButton = ({ disabled, onCall, deviceStatus }) => {
  const isLoading = deviceStatus === "initializing" || deviceStatus === "reconnecting";

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={`${styles.btn} ${!disabled ? styles.active : ""} ${isLoading ? styles.loading : ""}`}
        onClick={!disabled ? onCall : undefined}
        disabled={disabled}
        aria-label="Call"
      >
        {isLoading ? (
          <svg className={styles.spinner} width="26" height="26" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="rgba(255,255,255,0.35)" strokeWidth="2.5" />
            <path d="M12 3C7.03 3 3 7.03 3 12" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        ) : (
          <PhoneIcon />
        )}
      </button>
    </div>
  );
};

export default CallButton;
